import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Web3ReactProvider } from '@web3-react/core';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Web3 from 'web3';

import { MenuVisibilityProvider } from './contexts/MenuVisibilityContext';
import { ScrollProvider } from './contexts/ScrollContext';

import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { setupMockServiceWorker } from './setupMockServiceWorker';
import store from './store/store';

console.log('NFT Portal — deployed via GitHub Actions ✨');

function getLibrary(provider) {
  return new Web3(provider);
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);

setupMockServiceWorker();

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <MenuVisibilityProvider>
          <ScrollProvider>
            <Web3ReactProvider getLibrary={getLibrary}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </Web3ReactProvider>
          </ScrollProvider>
        </MenuVisibilityProvider>
    </Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
